import { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { Button, Col, Collapse, Row } from "reactstrap";
import { GiSpeaker } from "react-icons/gi";
import { useSpeechSynthesis } from "../../utils";
import { useTranslation } from "../../languages";

const FAQCard = ({ question, answer, index }) => {
  const [answerShown, setAnswerShown] = useState(false);
  const { isSpeakSupported, isSpeaking, speakText } = useSpeechSynthesis();
  const { t } = useTranslation();

  return (
    <Row className="mb-5">
      <Col md={2} xl={1} className="d-flex">
        <h3 className="m-0 figma-faq-label">
          {index?.toString()?.padStart(2, "0")}
        </h3>
      </Col>
      <Col md={8} xl={9}>
        <div>
          <h4 className={`f-6`}>{question}</h4>
          <Collapse isOpen={answerShown}>
            <h6 className="f-4 m-0 figma-faq-answer">{answer}</h6>
          </Collapse>
        </div>
      </Col>
      <Col md={2} className="d-flex justify-content-end">
        {isSpeakSupported && (
          <Button
            className={`full-rounded p-0 border-none mx-2 ${
              isSpeaking ? "text-white" : "text-black"
            }`}
            onClick={() => {
              let text = `${question} . ${answer}`;
              speakText(text);
            }}
            style={{
              height: "45px",
              width: "45px",
              aspectRatio: 1,
              background: isSpeaking
                ? "rgba(33, 0, 93, 1)"
                : "rgba(243, 245, 246, 1)",
            }}
          >
            <GiSpeaker size={20} />
          </Button>
        )}
        <Button
          onClick={() => setAnswerShown((prev) => !prev)}
          className={`full-rounded p-0 border-none ${
            answerShown ? "text-white" : "text-black"
          }`}
          style={{
            height: "45px",
            width: "45px",
            aspectRatio: 1,
            background: answerShown
              ? "rgba(33, 0, 93, 1)"
              : "rgba(243, 245, 246, 1)",
          }}
        >
          <FaPlus
            style={{
              transform: answerShown ? "rotate(134deg)" : "rotate(0deg)",
            }}
            size={15}
          />
        </Button>
      </Col>
    </Row>
  );
};

export default FAQCard;
